import React, { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import { LoginAction } from '../../actions/LoginAction';
import $ from 'jquery';
import { useDispatch, useSelector } from 'react-redux'
import { isLogin } from '../../actions/isLoginAction'
import { get_token, onMessageListener } from '../../firebase';
import axios from 'axios';




const LoginForm = () => {

    



    const dispatch = useDispatch()
    
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error_message, setError_message] = useState('');
    // const [isModal, setModal] = useState("true")
    let navigate = useNavigate();


    const login = (e) => {
        

        get_token().then(res => {
            LoginAction(email, password, res)
                .then(res => {
                    const data = res.data;
                    if (data.status == 0) {
                        setError_message(res.data.response.message);
                    } else {
                        $(".fade").click()
                        dispatch(isLogin(data.response.token))
                        navigate('/login_dashboard');
                    }
                })
                .catch(error => {
                    console.log(error);
                })

        });

        e.preventDefault();
    }
    return (

        <div class="login_form">
            <div class="modal fade" id="loginFormModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div class="modal-dialog">
                    <div class="modal-content">
                        <div class="modal-header">
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div class="modal-body">
                            <div class="container h-100">
                                <div class="d-flex justify-content-center h-100">
                                    <div class="user_card">
                                        <div class="d-flex justify-content-center">
                                            <div class="brand_logo_container">
                                                <img src="images/logo.jpg" class="brand_logo" alt="Logo" />
                                            </div>
                                            <h3>Sign in to your<br /> TRADE FINDRY Account</h3>
                                        </div>
                                        <div class="d-flex justify-content-center form_container">
                                            <form onSubmit={(e) => { login(e) }}>
                                                <div class="input-group mb-3">
                                                    <label class="custom-control-label" for="Email" >Email</label>
                                                    <input type="email" name="Email" class="form-control input_user" required value={email}
                                                        onChange={(e) => {
                                                            setEmail(e.target.value);
                                                            setError_message('');
                                                        }}

                                                    />
                                                </div>
                                                <div class="input-group mb-2">
                                                    <label class="custom-control-label" for="Password">Password</label>
                                                    <input type="password" name="Password" class="form-control input_pass" required value={password}
                                                        onChange={(e) => {
                                                            setPassword(e.target.value);
                                                            setError_message('');

                                                        }} />
                                                </div>

                                                <div class="d-flex justify-content-center mt-3 login_container">
                                                    <button type="submit" name="button" class="btn login_btn">Sign In</button>
                                                </div>
                                            </form>
                                            <span className='red error_message'>{error_message}</span>
                                        </div>
                                        <div class="mt-3">
                                            <div class="d-flex justify-content-center ">
                                                <a href="#" class="links" data-bs-dismiss="modal" aria-label="Close" data-bs-toggle="modal" data-bs-target="#forgotPasswordFormModal">Forgot your password?</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* <!-- <div class="modal-footer">
                                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                                <button type="button" class="btn btn-primary">Save changes</button>
                                </div> --> */}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LoginForm;